var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 15.6667L24.7601 19.729C24.848 19.7874 24.95 19.821 25.0554 19.826C25.1608 19.8311 25.2656 19.8074 25.3586 19.7576C25.4516 19.7078 25.5294 19.6337 25.5837 19.5432C25.6379 19.4527 25.6666 19.3492 25.6666 19.2437V9.68165C25.6667 9.57901 25.6396 9.47818 25.5882 9.38934C25.5368 9.3005 25.4629 9.22679 25.3739 9.17567C25.2849 9.12454 25.184 9.0978 25.0813 9.09815C24.9787 9.0985 24.8779 9.12592 24.7893 9.17765L18.6666 12.75",
    fill: "#FF8B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 15.6667L24.7601 19.729C24.848 19.7874 24.95 19.821 25.0554 19.826C25.1608 19.8311 25.2656 19.8074 25.3586 19.7576C25.4516 19.7078 25.5294 19.6337 25.5837 19.5432C25.6379 19.4527 25.6666 19.3492 25.6666 19.2437V9.68165C25.6667 9.57901 25.6396 9.47818 25.5882 9.38934C25.5368 9.3005 25.4629 9.22679 25.3739 9.17567C25.2849 9.12454 25.184 9.0978 25.0813 9.09815C24.9787 9.0985 24.8779 9.12592 24.7893 9.17765L18.6666 12.75",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 7.5H4.66671C3.37804 7.5 2.33337 8.54467 2.33337 9.83333V19.1667C2.33337 20.4553 3.37804 21.5 4.66671 21.5H16.3334C17.622 21.5 18.6667 20.4553 18.6667 19.1667V9.83333C18.6667 8.54467 17.622 7.5 16.3334 7.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCinema);
export default __webpack_public_path__ + "static/media/Icon-Cinema.536a0c24da7157045caa5cd251629462.svg";
export { ForwardRef as ReactComponent };